export const getUserBySpaceAndId = ({ userId }: { userId?: string }) => {
  return {
    queryKey: [`/v1/admin/organizations/:organizationId/spaces/:spaceId/users/basic/${userId}`]
  }
}
export const getUserById = ({ userId }: { userId?: string }) => {
  return {
    queryKey: [`/v1/admin/organizations/:organizationId/users/${userId}`]
  }
}
